import React from 'react';
import { Card, Typography, Space, Row, Col, Statistic, Spin } from 'antd';
import { MobileOutlined } from '@ant-design/icons';
import { useCustom } from '@refinedev/core';
import { TOKEN_KEY } from '../../authProvider';

interface DeviceAnalyticsProps {
  dateRange: { from: string; to: string };
}

export const DeviceAnalytics: React.FC<DeviceAnalyticsProps> = ({ dateRange }) => {
  const { data, isLoading, isRefetching } = useCustom({
    url: `${import.meta.env.VITE_API_URL}/admin/dashboard/active_wearable`,
    method: "get",
    config: {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem(TOKEN_KEY)}`
      },
      query: {
        from: dateRange.from,
        to: dateRange.to,
      }
    },
    queryOptions: {
       enabled: true,
    }
  });

  return (
    <>
      <Col span={24}>
        <Card
          title={
            <Space>
              <MobileOutlined style={{ fontSize: '24px', color: '#FF3131' }} />
              <Typography.Title level={5} style={{ margin: 0 }}>
                Connected devices
              </Typography.Title>
            </Space>
          }
        >
          {isLoading || isRefetching ? (
            <div style={{ 
              height: '200px', 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center' 
            }}>
              <Spin size="large" />
            </div>
          ) : (
            <>
              <Statistic
                title="Connected wearable accounts in this period"
                value={data?.data?.total || 0}
                prefix={<MobileOutlined />}
                style={{ marginBottom: 16 }}
              />

              <Typography.Text strong style={{ marginBottom: 16, display: 'block' }}>
                Provider breakdown
              </Typography.Text>
              
              <Row gutter={[12, 12]}>
                {data?.data?.byProvider?.map((item: {provider: string, count: number}) => {
                  const percentage = ((item.count / (data?.data?.total || 1)) * 100).toFixed(1);
                  const formattedProvider = item.provider.split('_').map(word => 
                    word.charAt(0) + word.slice(1).toLowerCase()
                  ).join(' ');
                  
                  return (
                    <Col key={item.provider} xs={24} sm={12} xl={6}>
                      <Card size="small" styles={{ body: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }}>
                        <Space direction="vertical" size={0}>
                        <Typography.Text strong>{formattedProvider}</Typography.Text>
                          <Typography.Text type="secondary">({percentage}%)</Typography.Text>
                        </Space>
                        <Typography.Text strong>{item.count}</Typography.Text>
                      </Card>
                    </Col>
                  );
                })}
              </Row>
            </>
          )}
        </Card>
      </Col>

    </>
  );
};
